<ng-container *transloco="let convert;">
  <div class="edit-posting-photos-form edit-posting-form">
    <h3 class="content-card-title">{{convert('sellModule.posting.photosForm.textPhotos')}}</h3>
    <div class="content-card-subtitle">
      {{convert('sellModule.posting.photosForm.textYouCanFifty')}}
    </div>
    <div class="mt-2 error-msg">{{errMsg}}</div>
    @if (!uploadedImgList?.length) {
      <div class="content-card-subtitle mt-3">{{convert('sellModule.posting.photosForm.textHaventUpload')}}</div>
    }
    <button class="btn btn-outline-primary mt-3"
      (click)="photoUploadService?.selectPhotos(vehicleVINNumber, photoFormCustomValidator)"
      data-track-name="Add Photos"
      [attr.aria-label]="convert('sellModule.posting.photosForm.ariaLabelAddPhotos')"
      allytm-click-tagged="true">
      {{convert('sellModule.posting.photosForm.ariaLabelAddPhotos')}}
    </button>
    @if (uploadedImgList?.length) {
      <div class="photos-form-img-container">
        <div class="col-md-12 ps-0 mt-5">
          <hr>
          </div>
          <div class="content-card-subtitle mt-2 mb-3">{{convert('sellModule.posting.photosForm.textSelectCheckbox')}}</div>
          <form class="body" name="photosForm">
            <app-photos-card
              [photoList]="uploadedImgList"
              [flowName]="'photo'"
              (photosCardDeletionStatus)="actionBarUpdatesFromPhotosCard($event)"
              [showMainImgTag]="doesImgListHaveFC"
              [locationOptList]="locationOptList"
              (photosCardLocationOptStatus)="saveSelectedLocOpt($event)"
            ></app-photos-card>
          </form>
        </div>
      }
    </div>
  </ng-container>
